/*
    Description: main reports overlay -- get user information with overlay before a user can download a report file
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

//import utility class for ajax call
import Utilities from "./utilities";

// report download overlay class
class Reports extends Utilities{

    // constructor
    constructor({

        // get DOM search box element
        reportsClass = "reports",
        submitAriaLabel = "Press enter or click submit to download the report file",
        optOutAriaLabel = "Click here to opt out of filling the required fields.",
        optOutCopy = "Opt Out",
        loadingBarClassName = "modal__wrapper__footer__loadingbar__bar",
        footerMsgClassName = "modal__wrapper__footer__messages",
        bodyPaddingClassName = "--reports-body-padding",
        headerClass = "modal__wrapper__header__title",
        reportClass = "download-report",
        submitLabel = "Download Report",
        title = "Download Report File",
        loadingClassName = "--loading",
        successClassName = "--success",
        errorClassName = "--error",
        hideClassName = "--hide"
        
    }={}){

        // get constructor/params from Utilities
        super();

        // get modal header class
        this.headerClass = headerClass;

        // get body padding class
        this.bodyPadding = bodyPaddingClassName;

        // get nonce
        this.nonce = reportClass;

        // footer msg area class name
        this.footerMsgClass = footerMsgClassName;

        // get selector prefix BEM Style class
        this.selectorPrefix = reportsClass;

        // submit button id
        this.submitID = `${this.selectorPrefix}__submit`;

        // submit aria label
        this.submitAriaLabel = submitAriaLabel;

        // opt out ID
        this.optOutID = `${this.selectorPrefix}__optout`;

        // opt out aria label
        this.optOutAriaLabel = optOutAriaLabel;

        // opt out copy
        this.optOut = optOutCopy;

        // form submission button label
        this.submitLabel = submitLabel;

        // loading status bar class (@ bottom of modal overlay)
        this.loadingBarClass = loadingBarClassName;

        // loading gif class
        this.loadingClass = loadingClassName;

        // success class
        this.successClass = successClassName;

        // error class
        this.errorClass = errorClassName;

        // hide class
        this.hideClass = hideClassName;
        
        // init download link - this is the orginal link that allows users to download the report file
        this.downloadLink = null;

        // init modal selector
        this.modal = null;
        
        // get title -- this is the fallback title
        this.title = title;

        // disclaimer copy
        this.disclaimer = "Sharing your email with us will help to further research partnership opportunities and share Arlington's TDM performance data with you. We respect your privacy and do not share email addresses with third parties.";
        
        // add listener
        this.listen();

    }

    // setup global listener
    listen(){
        
        // add event listener for optOut
        document.body.addEventListener("touchstart", this.optOutFields.bind(this));
        document.body.addEventListener("change", this.optOutFields.bind(this));

    }

    // add content to title
    setTitle(){

        // return title
        return (this.title) ? this.title : null;

    }

    // add content to body
    setBody(){
        
        // create our row labels
        const rowLabels = [
                {
                    "id":`${this.selectorPrefix}__fname`,
                    "name":`reportsFirstName`,
                    "placeholder":`First Name`,
                    "input-aria-label":"Enter your first name to download the report file",
                    "msg-aria-label":"Report file download first name output message area",
                },
                {
                    "id":`${this.selectorPrefix}__lname`,
                    "name":`reportsLastname`,
                    "placeholder":`Last Name`,
                    "input-aria-label":"Enter your last name to download the report file",
                    "msg-aria-label":"Report file download last name output message area",
                },
                {
                    "id":`${this.selectorPrefix}__company`,
                    "name":`reportsCompany`,
                    "placeholder":`Company Name`,
                    "input-aria-label":"Enter your company name to download the report file",
                    "msg-aria-label":"Report file download company name output message area",
                },
                {
                    "id":`${this.selectorPrefix}__email`,
                    "name":`reportsEmail`,
                    "placeholder":`Email`,
                    "input-aria-label":"Enter your email to download the report file",
                    "msg-aria-label":"Report file download email output message area",
                },

            ],
            output =  document.createElement("div"),        // tmp output div for our innerHTML return
            formWrapper = document.createElement("div"),    // form wrapper
            form = document.createElement("form");          // form div

            // add class to form wrapper
            formWrapper.classList.add(`${this.selectorPrefix}`);
            
            // add class to form
            form.classList.add(`${this.selectorPrefix}__form`);

            // create all row dynamically
            for(let i = 0; i < rowLabels.length; i++){

                // create row elements
                const rowWrapper = document.createElement("div"),   //create main row wrapper
                rowSubWrapper = document.createElement("div"),      //create main sub wrapper
                rowLastWrapper = document.createElement("div"),     //create last wrapper for the submit button                
                rowInput = document.createElement("input"),         //create row input
                rowMsg = document.createElement("div");             //create row msg area
                
                // add common classes for all rows
                rowWrapper.classList.add(`${this.selectorPrefix}__form__row`);
                rowWrapper.classList.add(`${rowLabels[i].id}__wrapper`);
                rowSubWrapper.classList.add(`${this.selectorPrefix}__form__row__input`);
                rowLastWrapper.classList.add(`${this.selectorPrefix}__form__row__input__wrapper`);
                rowInput.classList.add(`--${this.selectorPrefix}-shadow`);
                rowMsg.classList.add(`${this.selectorPrefix}__form__row__input__msg`);
                
                // add common attributes for all rows
                rowInput.setAttribute("id", rowLabels[i].id);
                rowInput.setAttribute("name", rowLabels[i].name);
                rowInput.setAttribute("type", "text");
                rowInput.setAttribute("placeholder", rowLabels[i].placeholder);
                rowInput.setAttribute("aria-label", rowLabels[i]["input-aria-label"]);
                rowMsg.setAttribute("aria-label", rowLabels[i]["msg-aria-label"]);
                rowMsg.setAttribute("aria-hidden", "true");

                // add submit on last row
                if(i >= (rowLabels.length - 1)){

                    // create submit button
                    const submitBttn = document.createElement("input");

                    // add submit button attributes
                    submitBttn.setAttribute("id", this.submitID);
                    submitBttn.setAttribute("type", "submit");
                    submitBttn.setAttribute("value", this.submitLabel);
                    submitBttn.setAttribute("aria-label", this.submitAriaLabel);
                    
                    // add submit button to current rowInput
                    rowLastWrapper.appendChild(rowInput);
                    rowLastWrapper.appendChild(rowMsg);
                    rowLastWrapper.appendChild(submitBttn);
                    rowWrapper.appendChild(rowLastWrapper);

                // normaly add elements to row 
                }else{

                    // attach elements together
                    rowSubWrapper.appendChild(rowInput);
                    rowSubWrapper.appendChild(rowMsg);
                    rowWrapper.appendChild(rowSubWrapper);

                }
                
                // add to form wrapper
                form.appendChild(rowWrapper);

            }

            // --------------------------------------------------------------------------------- //
            // DISCLAIMER ---------------------------------------------------------------------- //
            // --------------------------------------------------------------------------------- //

                const disclaimerField = document.createElement("p");
                disclaimerField.classList.add(`${this.selectorPrefix}__form__row__input__wrapper__disclaimer`);
                disclaimerField.textContent = this.disclaimer;
                disclaimerField.setAttribute("aria-hidden", "false");
                disclaimerField.setAttribute("tabindex", "15008");

                // add to email row
                form[3].parentNode.appendChild(disclaimerField);

            // --------------------------------------------------------------------------------- //
            // --------------------------------------------------------------------------------- //
            // --------------------------------------------------------------------------------- //


            // --------------------------------------------------------------------------------- //
            // OPT OUT ------------------------------------------------------------------------- //
            // --------------------------------------------------------------------------------- //

                // create opt out DOM 
                const optOutRowWrapper = document.createElement("div"),   //create main row wrapper
                optOutRowSubWrapper = document.createElement("div"),      //create main sub wrapper

                optOut = document.createElement("input"),
                optOutLable = document.createElement("label");

                // add classes
                optOutRowWrapper.classList.add(`${this.selectorPrefix}__form__row`);
                optOutRowSubWrapper.classList.add(`${this.selectorPrefix}__form__row__input`);
                optOutRowSubWrapper.classList.add(`opt__out`);

                // add opt out attributes
                optOut.setAttribute("id", this.optOutID);
                optOut.setAttribute("type", "checkbox");
                optOut.setAttribute("name", "optout");
                optOut.setAttribute("aria-label", this.optOutAriaLabel);
                optOut.setAttribute("aria-hidden", "true");
                optOutLable.setAttribute("for", this.optOutID);

                // add copy to label
                optOutLable.textContent = this.optOut;

                // append
                optOutRowSubWrapper.appendChild(optOut);
                optOutRowSubWrapper.appendChild(optOutLable);
                optOutRowWrapper.appendChild(optOutRowSubWrapper);
                form.appendChild(optOutRowWrapper);

            // --------------------------------------------------------------------------------- //
            // --------------------------------------------------------------------------------- //
            // --------------------------------------------------------------------------------- //

        // add form to form wrapper
        formWrapper.appendChild(form);

        // ---------------------------------------------- //
        // output --------------------------------------- //
        // ---------------------------------------------- //
        // add to form wrapper to output
        output.appendChild(formWrapper);

        // return output inner elements only
        return output.innerHTML;

    }

    // submit method
    submit(link){

        // get modal
        this.modal = document.querySelector(`.${this.selectorPrefix}`).parentNode.parentNode;

        // set link
        this.downloadLink = link.getAttribute("data-num");

        // get orginal link and header 
        const linkCopy = (link.getAttribute("title")) ? link.getAttribute("title") : null, 
        header = (this.modal && this.headerClass) ? this.modal.querySelector(`.${this.headerClass}`) : null,
        form = (this.modal) ? document.querySelector(`.${this.selectorPrefix}`) : null,
        submitBttn = (form) ? form.querySelector(`#${this.submitID}`) : null;

        // if we have the title tag add it as the title
        if(linkCopy && header) header.textContent = linkCopy;

        // submit bttn
        if(this.modal && submitBttn){

            // add event listener
            submitBttn.addEventListener("click", this.submission.bind(this));

        // ERROR
        }else{

            // display error msg 
            console.log(`%c Error: Could not find the element using the selector: '#${this.selectorPrefix}'!!!`, 'background:#f00; color:#fff');

        }

    }

    // submission method
    submission(e){

        // prevent default
        e.preventDefault();

        // get reports form
        const form = this.modal.getElementsByTagName("form")[0],
        nonce = document.getElementById(this.nonce);

        // make sure we have a form
        if(!form){

            // display error msg 
            console.log(`%c Error: Could not find the form element!!!`, 'background:#f00; color:#fff');

            // return
            return;

        }

        // set init
        const thisButton = e.target, 
        formData = new FormData(),
        footerMsg = this.modal.querySelector(`.${this.footerMsgClass}`),    
        loadingBar = this.modal.querySelector(`.${this.loadingBarClass}`),
        msgFields = this.modal.querySelectorAll(`.${this.selectorPrefix}__form__row__input__msg`),
        firstName = this.modal.querySelector(`#${this.selectorPrefix}__fname`),
        lastName = this.modal.querySelector(`#${this.selectorPrefix}__lname`),
        company = this.modal.querySelector(`#${this.selectorPrefix}__company`),
        email = this.modal.querySelector(`#${this.selectorPrefix}__email`),
        optout = this.modal.querySelector(`#${this.selectorPrefix}__optout`),
        nonceValue = (nonce) ? nonce.value : null;

        // add loading icon
        thisButton.classList.add(this.loadingClass);

        // append values
        formData.append(`${this.selectorPrefix}__fname`, (firstName) ? firstName.value : null);
        formData.append(`${this.selectorPrefix}__lname`, (lastName) ? lastName.value : null);
        formData.append(`${this.selectorPrefix}__company`, (company) ? company.value : null);
        formData.append(`${this.selectorPrefix}__email`, (email) ? email.value : null);
        formData.append(`${this.selectorPrefix}__download`, (this.downloadLink) ? this.downloadLink : null);
        formData.append(`${this.selectorPrefix}__optout`, (optout && optout.checked) ? true : false);
        formData.append(`${this.selectorPrefix}__url`, window.location.href);
        formData.append('wp_nonce', nonceValue);

        // make sure footer msg area exists - or display error and die
        if(!footerMsg){

            // display error msg
            console.log(`%c Error: Could not find the element using the selector: '.${this.footerMsgClass}'!!!`, 'background:#f00; color:#fff');
            return;

        }
        
        //reset footerMsg
        footerMsg.innerHTML = "";
        footerMsg.classList.remove(this.successClass, this.errorClass);

        // ajax call
        this.ajax({
            action:"reportsDownload",                               //go to "reportsDownload" ajax method
            data:formData,                                          //form data passed
            loadingBar:(loadingBar) ? loadingBar : null,            //loading bar element
            loading:thisButton                                      //bttn we clicked (to pass loading gif)
        // success
        }).then((results) => {
            
            // parse JSON
            results = JSON.parse(results);

            // SUCCESS: display success msg
            if(results.success){

                //hide form after success
                form.classList.add(this.hideClass);

                // get body (grandparent) and remove padding
                form.parentNode.parentNode.classList.add(this.bodyPadding);

                // add success class and msg txt
                footerMsg.classList.add(this.successClass);

                // add content
                footerMsg.innerHTML = results.success;

                // focus on footerMsg
                footerMsg.focus({preventScroll:true});

            // ERROR: display error msg
            }else{

                // make sure we have some kind of API error
                if(!results.error){

                    // display error msg
                    console.log(`%c Error: No data was received from the API.`, 'background:#f00; color:#fff');

                    // return
                    return;

                }

                // make sure msg area exists - or display error and die
                if((!msgFields)||(msgFields.length <= 0)){

                    // display error msg
                    console.log(`%c Error: Could not find the element using the selector: ${this.selectorPrefix}__form__row__input__msg'!!!`, 'background:#f00; color:#fff');
                    
                    // return
                    return;

                }

                // init firstError
                let firstError = null;

                //loop - all msg fields for error
                msgFields.forEach((item) => {

                    // clear msg area
                    item.textContent = "";

                    // grab input
                    const input = item.parentNode.getElementsByTagName('input')[0],
                    inputID = (input) ? input.id : null,
                    thisError = (inputID) ? results.error[inputID] : null;

                    // make sure input and error exists
                    if(input && thisError){

                        // add error class
                        item.classList.add(this.errorClass);

                        // enable screen readers to read msg
                        item.setAttribute("aria-hidden", "false");

                        // update error msg
                        item.textContent = thisError;

                        // check for an error
                        if(!firstError){

                            // set error
                            firstError = item;

                            // set focus
                            item.focus({preventScroll:true});
                            
                        }

                    }

                });

                // general error msg
                if(results.error.general){
                    
                    //add error class
                    footerMsg.classList.add(this.errorClass);

                    // append msg to msgRow
                    footerMsg.textContent = results.error.general;

                    // focus    
                    footerMsg.focus({preventScroll:true});

                }

            }

        // catch any errors
        }).catch((err) => {

            // display msg
            console.log(`%c Error: '${err}'.`, 'background:#f00; color:#fff');

        });

    }

    // if user opts out hide required fields
    optOutFields(e){
        
        // get target
        const target = e.target;

        if(target.id === this.optOutID){
            
            // get checkbox DOM
            const checkbox = document.querySelector(`#${this.optOutID}`);

            // check if checkbox exists
            if(checkbox){

                // get input nodes
                const inputs = document.querySelectorAll(`.${this.selectorPrefix}__form__row > div > input[type=text], .${this.selectorPrefix}__form__row__input__msg, .${this.selectorPrefix}__form__row__input__wrapper__disclaimer`),
                
                // get checkbox status
                optStatus = checkbox.checked;

                // LOOP: thru all nodes
                for(const field of inputs){

                    // updated class
                    (optStatus) ? field.classList.add(this.hideClass) : field.classList.remove(this.hideClass);

                }            
            
                // update disclaimer field
                const disclaimerTag = document.querySelector(`.${this.selectorPrefix}__form__row__input__wrapper__disclaimer`);
                
                // make sure we have disclaimer text
                if(disclaimerTag){

                    // update  sttribute
                    (optStatus) ? disclaimerTag.setAttribute("aria-hidden", "true") : disclaimerTag.setAttribute("aria-hidden", "false");
                    
                }

            }

        }

    }

}

// export
export default Reports;